import BigNumber from "bignumber.js";
const computeUtil = {
  getPlus: function(...arr) {
    //加
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.plus(newNext).toNumber();
    });
    return newNumber;
  },
  getMinus: function(...arr) {
    //减
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.minus(newNext).toNumber();
    });
    return newNumber;
  },
  getMultiply: function(...arr) {
    //乘
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.times(newNext).toNumber();
    });
    return newNumber;
  },
  getDivided: function(...arr) {
    //除
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.dividedBy(newNext).toNumber();
    });
    return newNumber;
  },
  getDividedToFormat: function(...arr) {
    //除
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.dividedBy(newNext).toFormat(2);
    });
    return newNumber;
  }
};

export default computeUtil;
